export default __webpack_public_path__ + "static/media/khaled_tweet.6b0b56c1.png";